module.exports = __webpack_public_path__ + "templates/modal-user-activated-success-tpl.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/modal-user-activated-success-tpl.html
// module id = qdgc
// module chunks = 1